import apiClient from '../services/apiClient';

export default {
	namespaced: true,
	state: {
		products: null,
		totalProducts: null,
		selectedProduct: null,
		options: {
			page_size: 20,
			search: '',
			sort: '',
			currentPage: 1,
			maxPages: null,
		}
	},
	getters: {
		products(state) {
			return state.products;
		},
		totalProducts(state) {
			return state.totalProducts;
		},
		selectedProduct(state) {
			return state.selectedProduct;
		},
		page_size(state) {
			return state.options.page_size;
		},
		sort(state) {
			return state.options.sort;
		},
		search(state) {
			return state.options.search;
		},
		maxPages(state) {
			return state.options.maxPages;
		},
		currentPage(state) {
			return state.options.currentPage;
		},
	},
	mutations: {
		SET_PRODUCTS(state, products) {
			state.products = products;
		},
		SET_TOTAL_PRODUCTS(state, totalProducts) {
			state.totalProducts = totalProducts;
		},
		SET_SELECTED_PRODUCT(state, selectedProduct) {
			state.selectedProduct = selectedProduct;
		},
		SET_MAX_PAGES(state, maxPages) {
			state.options.maxPages = maxPages;
		},
		SET_PAGE_SIZE(state, page_size) {
			state.options.currentPage = 1;
			state.options.page_size = page_size;
		},
		SET_SEARCH(state, search) {
			state.options.currentPage = 1;
			state.options.search = search;
		},
		SET_SORT(state, sort) {
			state.options.currentPage = 1;
			state.options.sort = sort;
		},
		SET_CURRENT_PAGE(state, currentPage) {
			state.options.currentPage = currentPage;
		},
		CLEAR_STORE(state) {
			state.products = null;
			state.totalProducts = null;
			state.selectedProduct = null;
			state.options.page_size = 20;
			state.options.search = '';
			state.options.sort = '';
			state.options.currentPage = 1;
			state.options.maxPages = null;
		}
	},
	actions: {
		async getProducts({commit, state}) {
			const params = {
				page_size: state.options.page_size,
				page: state.options.currentPage,
				search: state.options.search,
				sort_by: state.options.sort,
			};

			await apiClient.get('products/get', {params}).then(res => {
				commit('SET_PRODUCTS', res.data.products);
				commit('SET_TOTAL_PRODUCTS', res.data.totalProducts);
				const maxPages = Math.ceil(res.data.totalProducts / state.options.page_size);
				commit('SET_MAX_PAGES', maxPages);
			}).catch(err => {
			});
		},
		updateProducts({commit}, productsUpdate) {
			return new Promise((resolve, reject) => {
				apiClient.put('products/update', productsUpdate).then(res => {
					resolve();
				}).catch(err => {
					reject();
				});
			});
		},
		syncProducts({commit}, productId) {
			return new Promise((resolve, reject) => {
				const params = {
					product_id: productId,
				};
				apiClient.post('products/sync/create', params).then(res => {
					resolve();
				}).catch(err => {
					reject();
				});
			});
		},
		async clear({commit}) {
			commit('CLEAR_STORE')
		}
	},
}

